module.exports = __webpack_public_path__ + "static/artist-full-package-73747379ed0e6323fcf52d6e8e15cafb.pdf";